
import {extend} from 'vee-validate';
import {parsePhoneNumberFromString} from 'libphonenumber-js';

export default {
  props: {
    name: {
      type: String,
      default: ' '
    },
    rules: {
      type: String,
      default: ' '
    },
    message: {
      default: true
    },
    margin: {
      default: true
    }
  },
  created() {
    extend('validateBookingID', (value) => {
      if (value) {
        return new Promise((resolve, reject) => {
          this.$api.booking.verifyId(value)
              .then((res) => {
                resolve({
                  'valid': res.data.valid
                });
              })
              .catch(() => {
                resolve({
                  'valid': false
                });
              })
        })
      } else {
        return false;
      }
    });
    extend('validateBookingIDAndEMail', (value) => {
      if (value) {
        return new Promise((resolve, reject) => {
          this.$api.booking.verifyIdAndEMail(value)
              .then((res) => {
                resolve({
                  'valid': res.data.valid
                });
              })
              .catch(() => {
                resolve({
                  'valid': false
                });
              })
        })
      } else {
        return false;
      }
    });

    extend('phone', {
      validate: (value) => {
        if (!value || value === '') {
          return true;
        }
        const phoneNumber = parsePhoneNumberFromString(value, 'RO');
        return phoneNumber && phoneNumber.isValid();
      },
      message: this.$t('validation.phone_invalid'),
    });

    extend('validateIban', (value) => {
      return new Promise((resolve, reject) => {
        this.$api.paymentsHelper.verifyBankAccount(value)
            .then((res) => {
              resolve({
                'valid': true
              });
            })
            .catch(() => {
              resolve({
                'valid': false
              });
            });
      });
    });

    extend('date_before_x', {
      params: ['x'],
      validate: (value, { x }) => {
        // Access $moment through Vue prototype
        return this.$moment(value).isBefore(this.$moment(x));
      },
      // Message function should return a string
      message: (fieldName, placeholders) => {
        // Access $i18n through Vue prototype if you need locale-specific formatting
        const formatDate = this.$i18n.localeProperties.formatDate;
        return `The date must be before ${this.$moment(placeholders.x).format(formatDate)}`;
      }
    });

    extend('date_after_x', {
      params: ['x'],
      validate: (value, { x }) => {
        // Access $moment through Vue prototype
        return this.$moment(value).isAfter(this.$moment(x));
      },
      // Message function should return a string
      message: (fieldName, placeholders) => {
        // Access $i18n through Vue prototype if you need locale-specific formatting
        const formatDate = this.$i18n.localeProperties.formatDate;
        return `The date must be after ${this.$moment(placeholders.x).format(formatDate)}`;
      }
    });

    extend('emailNotRegistered', {
      params: ['email'],
      validate: async (value) => {
        try {
          const response = await this.$api.user.verifyUser(value);
          return !response.data.user;
        } catch (error) {
          return false;
        }
      },
      message: this.$t('validation.emailNotRegistered', {
        login: this.localePath({
          name: 'user-login'
        }),
        password: this.localePath({
          name: 'user-password'
        })
      }),
    });
  }
}
